// This needs to be separate from swidge.ts to avoid a circular dependency

/** Registry of available swidge providers */
export const SWIDGE_PROVIDERS = [
  'bebop',
  'bluefin',
  'cowSwap',
  'debridge',
  'enso',
  'jupiter',
  'lifi',
  'mayan',
  'oneClickNearIntents',
  'oogabooga',
  'oneInch',
  'oneInchFusion',
  'relay',
  'stargate',
  'uniswap',
  'across',
  'xswap',
  'renegade',
  'okx',
  'gaszip',
  'kyberswap',
  'titan',
  'dflow',
  'valiant',
  'houdini',
] as const;
export type SwidgeProvider = (typeof SWIDGE_PROVIDERS)[number];
